<app-resource-template [contentPadding]="false" [headerMarginBottom]="false" [footerStickyEnabled]="footerStickyEnabled">
  <div resource-content class="content alt-bg">
    <div id="layout-navigation" class="layout-navigation">
      <div class="content-heading text-center">
        <div class="container">
          <div class="content-heading__title">
            <h1 class="h1">{{ headerText }}</h1>
          </div>

          <app-content-heading-tabs
            [tabs]="tabs"
            [useAlternativeBackground]="true"
            (tabSelected)="setActiveTab($event)"
          ></app-content-heading-tabs>
        </div>
      </div>
    </div>

    <div class="faq-content" [ngSwitch]="activeTab">
      <div
        class="most-common-questions"
        *ngSwitchCase="FrequentlyAskedQuestionsTab.COMMON"
        [innerHTML]="commonQuestionsContent | safe : 'html'"
      ></div>

      <div
        class="patient-questions"
        *ngSwitchCase="FrequentlyAskedQuestionsTab.PATIENT"
        [innerHTML]="patientQuestionsContent | safe : 'html'"
      ></div>

      <div class="action-bar"></div>
      <div class="contact-section" [innerHTML]="footerContent | safe : 'html'"></div>
    </div>
  </div>
</app-resource-template>
